import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from '../forms/Icon';
import Input from '../forms/Input';
import { SCREEN_MAX_WIDTH } from '../stateProvider/StateProvider';
import { lastKeyPress } from '../utility/functions';
import { TableContext } from './Table';
import { BorderLessButton } from '../forms/Button';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5em;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        justify-content: space-between;
        width: 100%;
    }
`

const InputCSS = styled(Input)`
    width: 2rem;
`
const Element = styled.div`
    display: flex;
    gap: 0.5em;
    align-items: center;
`
const Chevron = styled(Icon)`
    font-size: 1.5rem;
    cursor: pointer;
    user-select: none;
    transform: rotate(${({ state }) => state ? '90deg' : '-90deg'});
`

const Pager = ({ ...props }) => {
    const { tableData, currentPage, itemsPerPage, setCurrentPage } = useContext(TableContext);

    const [pagerValue, setPagerValue] = useState(currentPage)
    const pageLimit = Math.ceil(tableData.length / itemsPerPage);

    useEffect(() => {
        setCurrentPage(1)
    }, [tableData])

    useEffect(() => {
        lastKeyPress.registerListener(key => {
            if (key === 'ArrowLeft') setCurrentPage(prevPage())
            if (key === 'ArrowRight') setCurrentPage(nextPage())
        });
        setPagerValue(currentPage)
    }, [currentPage, pageLimit])

    const prevPage = () => currentPage > 1 ? currentPage - 1 : currentPage;
    const nextPage = () => currentPage < pageLimit ? currentPage + 1 : currentPage;

    const handleInput = (val) => {
        val = parseInt(val.replace(/\D/g, ''))

        if (isNaN(val) || val < 0) {
            setCurrentPage(1)
            setPagerValue('')
        } else if (val > pageLimit) {
            setCurrentPage(pageLimit)
        } else {
            setCurrentPage(val)
        }
    }

    if (pageLimit < 2) return null;

    return (
        <Wrapper>
            <BorderLessButton
                onClick={() => setCurrentPage(prevPage())}
                label={<Chevron state={1} icon='chevronDown' />}
            />

            <Element>
                <InputCSS
                    value={pagerValue}
                    onInput={(e) => handleInput(e.target.value)}
                    type='tel'
                    standalone
                />
                <span>/ {pageLimit}</span>
            </Element>

            <BorderLessButton
                onClick={() => setCurrentPage(nextPage())}
                label={<Chevron state={0} icon='chevronDown' />}
            />
        </Wrapper >
    );
}

export default Pager;